import React, {Component} from 'react';
import {getStuff} from "../actions/weiChat";
import {UserOutlined} from "@ant-design/icons";
import {Scrollbars} from "react-custom-scrollbars";
import "./contentModal.css";
import * as Util from "../utils";

class ContentModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: '未填写标题',
            smallTitle: '',
            titlePic: '',
            summary: '',
            content: '',
            updateDate: '',
            author: ''
        }
    }

    componentDidMount() {
        this.loadStuff();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps.currentItem !== this.props.currentItem || nextProps.stuffId !== this.props.stuffId || nextProps.materialId !== this.props.materialId){
            this.loadStuff();
        }


    }

    loadStuff = () => {
        const { currentItem } = this.props;
        if(!this.props.materialId){
            let title, summary, content;
            if (this.props.signWords && this.props.signWords.length > 0) {
                title = Util.filtion(this.props.signWords, "<div>" + this.props.title?this.props.title:"未填写标题" + "</div>").value;
                summary = Util.filtion(this.props.signWords, "<div>" + this.props.summary?this.props.summary:"" + "</div>").value;
                content = Util.filtion(this.props.signWords, this.props.content).value;
            } else {
                title = "<div>" + this.props.title?this.props.title:"未填写标题" + "</div>";
                summary = "<div>" + this.props.summary?this.props.summary:"" + "</div>";
                content = this.props.content;
            }
            this.state.smallTitle = this.props.title;
            this.setState({
                ...this.props,
                title,
                summary,
                content,
                updateDate: window.formatDate(this.props.updateDate),
            })

        }else
        if(this.props.viewStuffId === undefined){
            this.setState({
                title: currentItem.title,
                smallTitle:currentItem.smallTitle,
                titlePic: currentItem.titlePic,
                summary: currentItem.summary,
                content: currentItem.content,
                updateDate:''

            })

        } else {
            let params = {
                materialId: this.props.materialId,
                stuffId: this.props.viewStuffId
            };
            getStuff({...params}, (res) => {
                //signWords 标记数组可传可不传
                let title, summary, content;
                if (this.props.signWords && this.props.signWords.length > 0) {
                    title = Util.filtion(this.props.signWords, "<div>" + res.title?res.title:'未填写标题' + "</div>").value;
                    summary = Util.filtion(this.props.signWords, "<div>" + res.summary?res.summary:'' + "</div>").value;
                    content = Util.filtion(this.props.signWords, res.content).value;
                } else {
                    title = "<div>" + res.title?res.title:'未填写标题' + "</div>";
                    summary = "<div>" + res.summary?res.summary:'' + "</div>";
                    content = res.content;
                }
                this.state.smallTitle = res.title;
                this.setState({
                    ...res,
                    title,
                    summary,
                    content,
                    updateDate: window.formatDate(res.updateDate),
                })
            });

        }

    };

    render() {
        console.log(this.props)
        return (
            <Scrollbars>
                <div style={{padding: "15px"}} >
                    <div style={{height: "100px"}}>
                        <table cellPadding={0} cellSpacing={0} border={0} height={100}>
                            <tbody>
                            <tr>
                                <td><img style={{objectFit: "cover", maxWidth: "180px"}} src={this.state.titlePic}
                                         height={"100px"}/></td>
                                <td style={{
                                    padding: "5px 10px",
                                    height: "100%",
                                    position: "relative",
                                    minWidth: "270px"
                                }} valign={"top"}>

                                    {/* <div style={{fontSize:"17px"}} >{this.state.title}</div>*/}
                                    <div title={this.state.smallTitle} style={{
                                        fontSize: "17px", display: '-webkit-box',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'normal',
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: '3',
                                    }}
                                         dangerouslySetInnerHTML={{__html: this.state.title?this.state.title:"未填写标题"}}></div>
                                    <div style={{position: "absolute", bottom: "5px"}}>
                                        <UserOutlined/>
                                        {/*<span*/}
                                        {/*    style={{marginLeft: "10px"}}>{this.state.author ? this.state.author : '佚名'}</span>*/}
                                        {
                                            this.props.mediaName ?
                                                <span
                                                    style={{marginLeft: "10px"}}>{this.props.mediaName ? this.props.mediaName : '佚名'}</span> : null}
                                        <span style={{marginLeft: "10px", marginRight: "10px"}}>|</span>
                                        <span>更新于{this.state.updateDate}</span>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    {/*<div style={{marginTop: "10px", paddingTop: "10px", borderTop: "1px solid #e8e8e8"}}>*/}
                    {/*    <div style={{fontSize: "17px", fontWeight: "bold"}}><span*/}
                    {/*        style={{marginRight: "8px", color: "#40a9ff"}}>|</span><span>摘要</span></div>*/}
                    {/*    /!* <div style={{textIndent:"2em",lineHeight:"24px"}}>{this.state.summary}</div>*!/*/}
                    {/*    <div style={{textIndent: "2em", lineHeight: "24px"}}*/}
                    {/*         dangerouslySetInnerHTML={{__html: this.state.summary?this.state.summary:""}}></div>*/}
                    {/*</div>*/}

                    <div style={{padding: "10px 0"}}>
                        <div style={{fontSize: "17px", fontWeight: "bold"}}><span
                            style={{marginRight: "8px", color: "#40a9ff"}}>|</span><span>内容</span></div>
                        <div style={{textIndex: "2em"}} id={"stuffContent"} className={'w-e-text'}
                             dangerouslySetInnerHTML={{__html: this.state.content}}/>
                       <style>
                           {`
                        .w-e-text table td, .w-e-text table th {
                        border-bottom: 1px solid #ccc;
                        border-right: 1px solid #ccc;
                        padding: 3px 5px;
                        min-height: 30px;
                        height:30px}
                       .w-e-text{overflow: hidden;}
                            `}
                        </style>
                    </div>
                </div>
            </Scrollbars>
        );
    }
}

export default ContentModal;